<template>
  <div class="Blockbox_right">
    <div class="blocktit">Average Gas Unit Price</div>
    <div class="blockboxlist">
      <div class="blockboxleft">
        <div class="blocktitl">
          <ul>
            <li>1m</li>
            <li>6m</li>
            <li>1y</li>
            <li class="active">All</li>
          </ul>
          <div class="blocktitr">
            <span>Jul 30,2015</span>
            <span>-></span>
            <span>Apr 18,2023</span>
          </div>
        </div>
        <div id="charts" ref="chart" style="width: 636px; height: 390px"></div>
      </div>
      <div class="blockboxright">
        <div class="boxright">
          <div class="blockrtit">About</div>
          <div class="blockrcton">
          The average gas price is the average cost of gas paid byall transactions and it can be used to indicate thecongestion level of the current TTOS network. If theaverage gas price is high, it means that the network ishandling a large volume of transactions and morecomputational resources are needed to execute themConversely, if the average gas price is low, it means thatthe network is handling a smaller volume oftransactions and fewer computational resources areneeded to execute them.
          </div>
        </div>
     
      </div>
    </div>
  </div>
</template>

<script>
import Homseach from "@/components/pc/serch.vue";
import leftcompo from "./../left.vue";
const echarts = require("echarts");
export default {
  data() {
    return {
      ind: 0,
      name: "",
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  watch: {
    // deep: true,
    $route: {
      handler: function (to) {
        console.log(to.query);
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    Homseach,
    leftcompo,
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "9%",
          left: "3%",
          right: "2%",
          bottom: "8%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#AC43FC",
                },
                {
                  offset: 0,
                  color: "#AC43FC",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#AC43FC",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [8232, 932, 9231, 3234, 19230, 12330, 12320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
  },
};
</script>

<style lang="less">
.Blockbox {
  display: flex;
  margin-top: 20px;

  .Blockbox_right {
    // margin-left: 20px;
    width: 852px;
    height: 571px;
    background: #000000;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    .blocktit {
      padding-top: 20px;
      // margin-left: 20px;
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
    }
    .blockboxlist {
      display: flex;
      margin-top: 20px;
      // border: 1px solid red;
      .blockboxleft {
        width: 634px;
        height: 485px;
        background: #0b0c0f;
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        // border: 1px solid yellow;
        margin-right: 20px;
        .blocktitl {
          margin-top: 20px;
          margin-left: 20px;
          margin-right: 20px;
          display: flex;
          justify-content: space-between;
          ul {
            display: flex;
            li {
              width: 33px;
              height: 20px;
              background: #1c1e24;
              border-radius: 5px 5px 5px 5px;
              opacity: 1;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 20px;
              margin-right: 10px;
              text-align: center;
            }
            .active {
              background: none;
              font-size: 14px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #00e79a !important;
            }
          }
        }
        .blocktitr {
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
        }
      }
      .blockboxright {
        width: 178px;
        height: 485px;
        background: #0b0c0f;
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        .boxright {
          margin-top: 20px;
          margin-left: 20px;
          margin-right: 20px;
          .blockrtit {
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
          .blockrcton {
            width: 100%;
            // border: 1px solid red;
            margin-top: 10px;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #898b8d;
            line-height: 17px;
           
          }
        }
      }
    }
  }
}
</style>
